
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { FlightBookingDetails } from "../../Services/API"


const PrintInvoice = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const referenceNo = queryParams.get("ReferenceNo");
    const key = queryParams.get("key");
    const clientCode = queryParams.get("clientCode");
    const trackID = queryParams.get("trackID");


    const [flightDetails, setFlightDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const [paxCount, setPaxCount] = useState("");
    const [companyAmount, setCompanyAmount] = useState(0);
    const [companyMarkUp, setCompanyMarkUp] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalBaseFare, setTotalBaseFare] = useState(0);
    const [totalOtherTax, setTotalOtherTax] = useState(0);
    const [totalFuelSurcharge, setTotalFuelSurcharge] = useState(0);
    const [netAmount, setNetAmount] = useState(0);
    const [managementFeeTax, setManagementFeeTax] = useState(0);
    const [managementFee, setManagementFee] = useState(0);
    const [sector, setSector] = useState(null);
    const [flight, setFlight] = useState(null);
    const gstRequest = flightDetails?.gstRequest || {};
    const [ssrAmount, setSsrAmount] = useState(0);
    const [airlineGST, setAirlineGST] = useState(0);

    useEffect(() => {
        if (referenceNo && trackID) {
            fetchFlightBookingDetails(referenceNo, trackID);
        } else {
            console.warn("Missing referenceNo or trackID ");
        }
    }, [referenceNo, trackID]);

    const fetchFlightBookingDetails = async (referenceNo, trackID) => {
        try {
            setLoading(true);
            setError("");
            const params = { ReferenceNo: referenceNo, TrackID: trackID, ClientCode: "BerryJourneys", Key: "", SessionID: "" };
            const response = await FlightBookingDetails(params);
            setFlightDetails(response);

            const paxcount = response?.airBookingResponse[0]?.customerInfo?.passengerTicketDetails?.length;
            setPaxCount(paxcount);
            const BookingResponse = response?.airBookingResponse?.[0];

            const CompanyAmount = BookingResponse?.fareDetails?.companyAmount || 0;
            const CompanyMarkUp = BookingResponse?.fareDetails?.companyMarkUp || 0;
            const TotalAmount =
                (BookingResponse?.fareDetails?.totalFare || 0) +
                (BookingResponse?.ssrAmount || 0);
            const NetAmount = BookingResponse?.fareDetails?.netAmount || 0;
            const totalBaseFare = BookingResponse?.fareDetails?.totalBaseFare || 0;
            const totalOtherTax = BookingResponse?.fareDetails?.totalOtherTax || 0;
            const totalFuelSurcharge = BookingResponse?.fareDetails?.totalFuelSurcharge || 0;

            const managementFeeTax = BookingResponse?.fareDetails?.managementFeeTax || 0;
            const managementFee = BookingResponse?.fareDetails?.managementFee || 0;
            const airlineGST = BookingResponse?.fareDetails?.airlineGST || 0;

            // var BookingResponse = response?.airBookingResponse[0];
            // const CompanyMarkUp = BookingResponse?.fareDetails?.companyMarkUp;
            // const TotalAmount = BookingResponse?.fareDetails?.totalFare + response?.airBookingResponse[0]?.ssrAmount;
            // const NetAmount = BookingResponse.fareDetails.netAmount;

            var Sectors = BookingResponse?.origin + "-" + BookingResponse?.destination;
            const flight = BookingResponse?.flightDetails?.reduce((acc, segment, index) => {
                return acc + (index > 0 ? ", " : "") +
                    `${segment.airLineCode} - ${segment.flightNumber}`;
            }, "");

            setCompanyAmount(CompanyAmount);
            setCompanyMarkUp(CompanyMarkUp);
            setTotalAmount(TotalAmount);
            setNetAmount(NetAmount);
            setTotalBaseFare(totalBaseFare);
            setTotalOtherTax(totalOtherTax);
            setTotalFuelSurcharge(totalFuelSurcharge);
            setManagementFeeTax(managementFeeTax);
            setManagementFee(managementFee);
            setSector(Sectors);
            setFlight(flight);
            setAirlineGST(airlineGST);

            // console.log("FlightBookingDetails", response);

        } catch (err) {
            setError("Failed to load flight Booking details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "";

        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };
    const formatDateTime = (dateStr) => {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "";

        return date.toLocaleString("en-IN", {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    useEffect(() => {
        if (!loading && flightDetails) {

            const waitForImages = async () => {
                const images = Array.from(document.images);

                await Promise.all(
                    images.map(img => {
                        if (img.complete) return Promise.resolve();

                        return new Promise(resolve => {
                            img.onload = resolve;
                            img.onerror = resolve;
                        });
                    })
                );

                setTimeout(() => {
                    window.focus();
                    window.print();
                }, 300);
            };

            waitForImages();
        }
    }, [loading, flightDetails]);


    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}

            {loading && (
                <div id="view-content" style={{ background: 'white' }}>
                    <p style={{ textAlign: "center" }}>
                        Loading ticket details...
                    </p>
                </div>
            )}
            {flightDetails && flightDetails.airBookingResponse.length > 0 && (
                <>
                    <div id="view-content" style={{ background: 'white' }}>
                        <div class="header-bg">
                            <div class="invoice_logo"></div>
                            <div class="top_details">
                                <p class="top_p right_txt">
                                    <p className="top_p right_txt">
                                        <strong>Invoice Date : </strong>{" "}
                                        <span style={{ color: "red", fontWeight: "600" }}>
                                            {formatDate(flightDetails.airBookingResponse?.[0]?.bookingDate)}
                                        </span>
                                    </p>
                                    {/* <p className="top_p right_txt">
                                        <strong>Status : </strong>{" "}
                                        <span style={{ color: "green", fontWeight: "600" }}> {flightDetails.airBookingResponse?.[0]?.bookingStatus}</span>
                                    </p> */}
                                </p>
                            </div>
                        </div>
                        <div class="invoice_body">
                            <div class="agent_container">
                                <h2 class="center_txt invoicenumber">
                                    <span>
                                        Invoice Number - {
                                            flightDetails?.airBookingResponse?.[0]?.invoiceNumber?.trim()
                                                ? flightDetails.airBookingResponse[0].invoiceNumber
                                                : flightDetails?.transactionID
                                        }
                                    </span>
                                </h2>
                                <div class="agent_details">
                                    <div class="agent_details-left">
                                        <h3>From</h3>
                                        <h4 class="captaize">{flightDetails.companyDetails.name}</h4>
                                        <p> <strong>Regd Office :</strong> {flightDetails.companyDetails.address}</p>
                                        <p>{flightDetails.companyDetails.city}, {flightDetails.companyDetails.country} -{flightDetails.companyDetails.pincode}</p>
                                        <p> <strong>Email :</strong> {flightDetails.companyDetails?.email}</p>
                                        <p> <strong>Phone :</strong> {flightDetails.companyDetails?.phone}</p>
                                        <p> <strong>State :</strong> {flightDetails.companyDetails?.gstState}</p>
                                        <p> <strong>GSTIN :</strong> {flightDetails.companyDetails?.gstNo}</p>
                                        <p> <strong>CIN :</strong> U93000UR2010PTC033270</p>
                                    </div>
                                    <div class="agent_details-right">
                                        <h3>To</h3>
                                        <h4 class="captaize">{flightDetails.corporateDetails.companyName}</h4>
                                        <p> <strong>Address :</strong> {flightDetails.corporateDetails?.address}</p>
                                        <p> {flightDetails.corporateDetails?.city}, {flightDetails.corporateDetails?.country} - {flightDetails.corporateDetails?.pinCode}</p>
                                        <p> <strong>Email :</strong> {flightDetails.corporateDetails?.email}</p>
                                        <p> <strong>Phone :</strong> {flightDetails.corporateDetails?.phoneNumber}</p>
                                        <p> <strong>State :</strong> {flightDetails.corporateDetails?.state}</p>
                                        <p> <strong>GST Number :</strong> {flightDetails.corporateDetails?.gstNumber}</p>

                                    </div>
                                </div>
                            </div>

                            {flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerTicketDetails?.length > 0 && (
                                <>
                                    <div class="ticket_details-container">
                                        <table class="tkt_details-table invoice_table">
                                            <thead>
                                                <tr>
                                                    <th>S No.</th>
                                                    <th>Ticket No.</th>
                                                    <th>PNR No.</th>
                                                    <th>Sectors</th>
                                                    <th>Flight</th>
                                                    <th>Name</th>
                                                    <th>Travel Date</th>
                                                    <th>Base Fare</th>
                                                    <th>OT Tax</th>
                                                    <th>YQ Tax</th>
                                                    <th>K3/GST</th>
                                                    <th>SSR</th>
                                                    <th>Mgmt Fee</th>
                                                    <th>Mgmt Tax</th>
                                                    <th>Total Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {flightDetails.airBookingResponse[0].customerInfo.passengerTicketDetails.map(
                                                    (pax, paxIndex) => (
                                                        <tr key={paxIndex}>
                                                            <td data-title="S.NO">{paxIndex + 1}</td>
                                                            <td data-title="Ticket No">{pax.ticketNumber || "NA"}</td>
                                                            <td data-title="Ticket No">{pax.ticketNumber || "NA"}</td>
                                                            <td data-title="Sectors">{sector}</td>
                                                            <td data-title="Flight">{flight}</td>
                                                            <td data-title="Name">
                                                                {pax.title} {pax.firstName} {pax.lastName}
                                                            </td>
                                                            <td data-title="traveldate">{formatDateTime(flightDetails.airBookingResponse[0].flightDetails[0].departDateTime)}</td>
                                                            {/* <td data-title="Fare">
                                                                {
                                                                    flightDetails?.airBookingResponse?.[0]?.fareDetails?.paxFareDetails
                                                                        ?.find(x =>
                                                                            x.paxType?.trim().toUpperCase() === pax.paxType?.trim().toUpperCase()
                                                                        )?.paxBaseFare || 0
                                                                }
                                                            </td>
                                                            <td data-title="Fare">
                                                                {
                                                                    flightDetails?.airBookingResponse?.[0]?.fareDetails?.paxFareDetails
                                                                        ?.find(x =>
                                                                            x.paxType?.trim().toUpperCase() === pax.paxType?.trim().toUpperCase()
                                                                        )?.paxOtherTax || 0
                                                                }
                                                            </td>
                                                            <td data-title="Fare">
                                                                {
                                                                    flightDetails?.airBookingResponse?.[0]?.fareDetails?.paxFareDetails
                                                                        ?.find(x =>
                                                                            x.paxType?.trim().toUpperCase() === pax.paxType?.trim().toUpperCase()
                                                                        )?.paxFuelSurcharge || 0
                                                                }
                                                            </td> */}

                                                            <td data-title="Fare">{totalBaseFare / paxCount}</td>
                                                            <td data-title="OT Tax">{(totalOtherTax + companyMarkUp - airlineGST - totalFuelSurcharge) / paxCount}</td>
                                                            <td data-title="YQ Tax">{totalFuelSurcharge / paxCount}</td>
                                                            <td data-title="K3/GST">{airlineGST / paxCount}</td>
                                                            {/* <td data-title="Bag Ch">{baggageCharge}{seatCharge}{mealCharge}</td> */}
                                                            <td data-title="SSR Amount">
                                                                {Number(
                                                                    flightDetails?.airBookingResponse?.[0]?.ssrAmount || 0
                                                                ).toFixed(2)}
                                                            </td>
                                                            {/* <td data-title="Bag Ch">0.00</td>
                                                            <td data-title="Bag Ch">0.00</td> */}
                                                            <td data-title="Service Charge">{managementFee / paxCount}</td>
                                                            <td data-title="Service Charge">{managementFeeTax / paxCount}</td>
                                                            <td data-title="Total Charge">
                                                                {
                                                                    (totalBaseFare / paxCount) +
                                                                    ((totalOtherTax + companyMarkUp - airlineGST - totalFuelSurcharge) / paxCount) +
                                                                    (totalFuelSurcharge / paxCount) +
                                                                    (airlineGST / paxCount) +
                                                                    Number(flightDetails?.airBookingResponse?.[0]?.ssrAmount || 0) +
                                                                    (managementFee / paxCount) +
                                                                    (managementFeeTax / paxCount)
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                            <div class="bill_container">
                                <div class="bill_details">
                                    {/* <div class="bill_info">
                                        <h3>
                                            GST Details
                                            :
                                        </h3>
                                        <table class="bill_table">
                                            <tr>
                                                <th>Description</th>
                                                <td>CGST @9%</td>
                                                <td>SGST @9%</td>
                                                <td>IGST 18@%</td>
                                            </tr>
                                            <tr>
                                                <th>Management Fee GST</th>
                                                <td>{Number(flightDetails.airBookingResponse[0].fareDetails.cgst).toFixed(2)}</td>
                                                <td>{Number(flightDetails.airBookingResponse[0].fareDetails.sgst).toFixed(2)}</td>
                                                <td>{Number(flightDetails.airBookingResponse[0].fareDetails.igst).toFixed(2)}</td>
                                            </tr>
                                        </table>
                                    </div> */}
                                    <div class="bill_breakup">
                                        <table class="bill_table invoice_table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>
                                                        <strong>Gross:</strong>
                                                    </th>
                                                    <th class="right_txt"><strong>{Number(totalAmount).toFixed(2)}</strong></th>
                                                </tr>
                                            </thead>
                                            {/* <tbody>
                                                <tr>
                                                    <td class="italic_font">
                                                        Less
                                                        :
                                                    </td>
                                                    <td>Flight Commission Earned</td>
                                                    <td class="right_txt">0.00</td>
                                                </tr>
                                                <tr>
                                                    <td class="italic_font">
                                                        Add
                                                        :
                                                    </td>
                                                    <td>Flight TDS Deducted</td>
                                                    <td class="right_txt">0.00</td>
                                                </tr>
                                            </tbody> */}
                                            <tr class="botm_brdr_tr">
                                                <td></td>
                                                <td><strong>Total Amount</strong></td>
                                                <td class="right_txt"><strong>₹ {Number(totalAmount).toFixed(2)}</strong></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div>
                                {gstRequest?.gstNumber?.trim() && (
                                    <>
                                        <h3 class="address-head"> Passenger GST Details</h3>
                                        {gstRequest?.gstNumber && (
                                            <table
                                                style={{
                                                    border: "1px solid #333",
                                                    width: "100%",
                                                    borderCollapse: "collapse",
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        {["GST Name", "GST No", "GST Email", "GST Phone", "GST Address"].map(
                                                            (heading, index) => (
                                                                <th
                                                                    key={index}
                                                                    style={{
                                                                        border: "1px solid #333",
                                                                        padding: "6px",
                                                                        background: "#110942",
                                                                        color: "#dacd65",
                                                                        fontSize: "14px",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    {heading}
                                                                </th>
                                                            )
                                                        )}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                            {gstRequest?.name || "NA"}
                                                        </td>

                                                        <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                            {gstRequest?.gstNumber || "NA"}
                                                        </td>

                                                        <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                            {gstRequest?.email || "NA"}
                                                        </td>

                                                        <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                            {gstRequest?.contactNo || "NA"}
                                                        </td>
                                                        <td style={{ border: "1px solid #333", padding: "6px", textAlign: "center" }}>
                                                            {gstRequest?.address || "NA"}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )}
                                    </>
                                )}
                            </div>
                            <div>
                                <div class="footer-terms">
                                    <h3 class="address-head" style={{ marginTop: "20px" }}>
                                        Terms and Conditions E. & O.E
                                        :
                                    </h3>
                                    <ol>
                                        <li>Payment to be made as per contracted terms and printed official receipt must be obtained.</li>
                                        <li>All cheques / demand drafts in payment of bills must be crossed 'A/c Payee Only' and drawn in favour of BERRY JOURNEYS PRIVATE LIMITED</li>
                                        <li>Interest @ 24% per annum will be charged on all outstanding bills after due date.</li>
                                        <li>Kindly check all details carefully before accepting the tickets/utilizing the service.</li>
                                        <li>Refunds & Cancellations are subject to Airlines approval.</li>
                                        <li>Please resolve any discrepancies with this invoice within 30 days of the invoice date.</li>
                                        <li>Subject To HARYANA Jurisdiction</li>
                                    </ol>
                                </div>
                            </div>
                            <div class="pagebreakAfter"></div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default PrintInvoice;
